/*
  中文
*/

export default {
  // 支付
  common: {
    default: '默认',
    delete: '删除',
    cancel: '取消',
    submit: '提交',
    inputContent: '请输入内容',
    selectContent: '请选择内容',
    pleaseEnter: '请输入',
    confirm: '确认',
    Warning: '提示',
    success: '操作成功',
    next: '下一步'
  },
  payment: {
    payment: '支付',
    availableBalance: '可用余额',
    topUp: '充值',
    creditCard: '信用卡',
    settings: '设置',
    transactions: '交易',
    paymentMethods: '支付方式',
    type: '类型',
    orderNumber: '订单编号',
    amount: '金额',
    transactionTime: '交易时间',
    allType: '所有类型',
    expenditure: '支出',
    income: '收入',
    balance: '余额',
    refund: '退款',
    sample: '样品',
    purchase: '购买',
    orderGoods: '订货',
    cardNo: '信用卡号码',
    expireDate: '过期时间',
    addCard: '添加信用卡',
    startDate: '开始时间',
    endDate: '结束时间',
    export: '导出',
    enterAmount: '请输入充值金额',
    dropshipping: '一件代发',
    recharge: '充值',
    orderDeposit: '订单定金',
    orderBalance: '订单余额',
    systemTopup: '系统充值',
    giftCard: '礼品卡'
  },
  // 地址
  address: {
    address: '地址',
    editTheAddress: '编辑地址',
    setAsDefault: '设为默认地址',
    addAddress: '新增地址',
    fullName: '全名',
    phoneNumber: '电话号码',
    streetAddressLine1: '街道一',
    streetAddressLine2: '街道二',
    city: '城市',
    state: '州',
    provice: '省',
    region: '区',
    country: '国家',
    zipCode: '邮编',
    vat: '税号',
    setAsDefaultAddress: '设为默认地址',
    defaultAddress: '默认地址',
    stateProviceRegion: '州/省/地区',
    deleteTip: '确定要删除当前地址吗?'
  },
  // 店铺
  store: {
    store: '店铺',
    stores: '店铺',
    allStores: '所有店铺',
    storeTips: '添加商店后，您只需单击几下即可在商店中发布数以万计的流行商品。 在您的商店下订单后，KakaClo 将为您处理所有其他事情。',
    allowStoreBinding: '允许绑定的店铺',
    connectANewStore: '关联新店铺',
    authorized: '已授权',
    unauthorized: '未授权',
    reauthorize: '重新授权',
    storeSettings: '店铺设置',
    removeStoreTitle: '您确定要移删除店铺吗?',
    removeStoreTips: '如果您只是想停止将商店数据同步到我们的平台并保留您的商店设置，您可以停用商店而不是将其删除。',
    removeStoreTips1: '商店被移除后，与该商店关联的以下数据也将被移除且无法恢复：',
    listings: '产品链接',
    OrdersOfstore: '店铺订单.',
    removeTheStore: '删除店铺',
    storeUrl: '店铺链接',
    openStoreMsg: '恭喜成功激活店铺,你将接收到你所绑定的店铺订单!',
    closeStoreAlert: '请确认是否要关闭您的店铺?',
    closeStoreTips: '如果店铺关闭,你将无法收到店铺的订单.',
    closeStoreMsg: '您已关闭商店，您可以重新打开商店以接收订单。',
    chooseStoreTip: '选择您的店铺平台',
    addStoreTip: '仅输入',
    addStoreTip2: '您的默认域',
    shopifyTips: '登录到您的 Shopify 后台以查找您的默认域。',
    shopifyTips1: 'www.Your-Default-Domain.myshopify.com',
    shoplazzaTips: '登录您的 Shoplaza 管理员以查找您的默认域。',
    shoplazzaTips1: 'www.Your-Default-Domain.shoplaza.com',
    shoplineTips: '登录您的 Shopline 管理员以查找您的默认域。',
    shoplineTips1: 'www.Your-Default-Domain.shopline.com',
    eg: '例如:',
    addStoreVideoTip: '如何绑定新商店'
  },
  // 店铺设置
  storeSetting: {
    storeStting: '店铺设置',
    storeName: '店铺名称',
    whetherToAuthorize: '是都授权',
    storeLink: '店铺链接',
    taxRuleTitle: '产品是否收税',
    taxRuleTip: '指定在销售产品变体时是否收取税费.',
    productRules: '产品规则',
    productRuleTip: '关联到您店铺的商品SKU的库存发生变化时,请选择一个操作。',
    dontDealWidth: '不操作',
    productRuleY: '自动更新商店 SKU 库存',
    priceRules: '价格规则',
    storeCurrency: '店铺币种',
    compareAtPrice: '比较价格',
    price: '价格',
    originalPrice: '建议售价',
    multiplier: '倍',
    shipping: '运费',
    orderRules: '订购规则',
    orderRulesTip1: '当店铺的订单发货供应商发货时，请选择一个操作。',
    orderRulesY: '自动上传物流单号到店铺',
    orderRulesTip2: '当您的商店收到新的等待订单时，是否自动购买。',
    orderRulesTip2N: '不自动购买',
    orderRulesTip2Y: '自动购买',
    save: '保存',
    selectCurrency: '选择币种',
    productCost: '产品成本'
  },

  // 注册身份
  signupUser: {
    questionTile: '以下哪一项最符合您 ：',
    answer1: '我经营或管理服装网店',
    answer2: '我经营或管理线下服装门店',
    answer3: '我经营或管理线上和线下服装商店',
    answer4: '我是一个Influencer',
    answer5: '我是消费者',
    answer6: '其他'
  },
  // my information
  myInformation: {
    myInformation: '个人信息'
  }
}
